<template>
  <div class="feed-card feed__message-block messagerie-item truck-message">
    <div class="d-flex position-relative">
      <span class="v-line"></span>
      <span class="circle-step icon flex-shrink-0">
				<CommentDots />
      </span>

      <div class="content">
        <h3 v-html="userActivity.title_html"></h3>
        {{ formattedMessage }}


        <TimeInfos :userActivity="userActivity"/>
      </div>
    </div>
  </div>


  </template>

<script>
  import Autolinker from "autolinker";
  import TimeInfos from '@components/utils/TimeInfos.vue';
  import CommentDots from '@images/CommentDots.vue';

  export default {
    props: {
      userActivity: Object,
    },
    components: {
      TimeInfos,
	  CommentDots
    },
    data() {
      return {
        formattedMessage: ''
      }
    },
    mounted() {
      this.formattedMessage = this.formatMessage(this.userActivity.data.message);
    },
    methods: {
      formatMessage(message) {
        const cleaned = message.replace(/<\/?(?:interaction|message)(?:\s[^>]*)?>/gi, '');
        return Autolinker.link(cleaned);
      },
    }
  };
</script>
